import JSZip from "jszip";
import store from '../store/index';
export default {
    dictionary(code) {
        // 获取所有字典参数
        const dictionaryList = store.state.dictData.data;
        let zdList = [];
        dictionaryList.forEach((key) => {
            if (key.code == code) {
                zdList.push(key);
            }
        });
        return zdList;
    },
    // 二维码下载
    downloadImagesAsZip(data) {
        const zip = new JSZip();

        // 遍历所有图片 URL，使用 fetch 方法获取图片数据并添加到 ZIP 文件中
        data.forEach((key, index) => {
            fetch(key.url)
                .then((response) => response.blob())
                .then((blob) => {
                    const fileName = `${key.name}————二维码.${blob.type.split("/")[1]}`;

                    // 将图片数据添加到 ZIP 文件中
                    zip.file(fileName, blob);

                    // 如果已经处理完所有图片，则生成 ZIP 文件并下载
                    if (index === data.length - 1) {
                        zip.generateAsync({ type: "blob" }).then((blob) => {
                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob);
                            link.download = '分析单元二维码';
                            link.click();
                        });
                    }
                });
        });
    },
    // 将文件下载到本地
    downloadFile(url, fileName) {
        const zip = new JSZip();
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName; // 确保文件名有效且简单
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a); // 点击后移除元素
            })
            .catch(error => console.error('下载失败', error));
    }
}
